import storeConfig from '../../store.config'

const { sc } = storeConfig

export const B2C = {
  accountName: 'decathlonstore',
  checkoutUrl: '/checkout/cart',
  accountUrl: '/account',
  salesChannel: Number(sc),
  gtmContainerId: 'GTM-T777CVM',
  gtmContainerId2: 'GTM-W9G828C4',
  loginUrl: 'https://secure.decathlon.com.br/api/io/login',
}
